<template>
  <div
    class="left_record"
    :class="[
      styleType == 'typeGreen'
        ? 'left_record_green'
        : styleType == 'typeBlue'
        ? 'left_record_blue'
        : '',
      'left_record',
    ]"
  >
    <div class="door_title">
      <door-title>运输车辆电子台账</door-title>
      <div class="public-form form_box">
        <el-form :inline="true">
          <el-form-item label="车辆运输类型" v-if="customerId == 60">
            <el-select v-model="transportType">
              <el-option
                v-for="(item, i) in transportTypeList"
                :key="i"
                :value="item.value"
                :label="item.label"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="排放标准" v-if="customerId == 42">
            <el-select v-model="emissionType">
              <el-option
                v-for="(item, i) in emissionStandard"
                :key="i"
                :value="item.value"
                :label="item.label"
              ></el-option>
            </el-select>
          </el-form-item>
          <!--          <el-form-item label="进出厂" v-if="customerId == 54">
            <el-select v-model="inOutFlag">
              <el-option :value="1" label="进厂"></el-option>
              <el-option :value="0" label="出厂"></el-option>
            </el-select>
          </el-form-item>-->
          <!-- <el-form-item label="车牌号：" v-if="customerId == 59">
            <el-input type="text" v-model="selectNumberPlate"  placeholder="请输入车牌号"></el-input>
          </el-form-item>
          <el-form-item label="物料名称：" v-if="customerId == 59">
            <el-input type="text" v-model="materialsName"  placeholder="请输入物料名称"></el-input>
          </el-form-item>-->
          <el-form-item label="起止时间">
            <!--            <el-date-picker
              v-model="timeArr"
              type="datetimerange"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="date_change"
              @focus="timeFocus"
              @blur="timeBlur"
              style="width: 445px"
              :disabledDate="pickerOptions"
            >
              &lt;!&ndash; value-format="yyyy-MM-dd HH:mm"  &ndash;&gt;
            </el-date-picker>-->
            <DatePicker
              :init-width="'420px'"
              :formatType="'YYYY-MM-DD HH:mm:ss'"
              dateType="timerange"
              :currentDateList="createTime"
              :needInitTime="false"
              topPx="50px"
              @dateChange="date_change"
            ></DatePicker>
          </el-form-item>
          <el-form-item style="margin-top: 5px; margin-right: 0">
            <a class="self_btn" @click="record_check_click">查询</a>
            <a class="self_btn" @click="record_reset_click">重置</a>
            <!-- <a class="self_btn" @click="exportExel" v-if="customerId == 59 || customerId == 45">导出</a> -->
            <!-- <a class="self_btn" @click="exportExel" v-if="customerId == 45"
              >导出</a
            >-->
            <a
              class="self_btn"
              @click="showListOverview"
              v-if="isNewCleanTransport"
              >清单总览</a
            >
            <a
              class="self_btn"
              @click="showListTransport"
              v-if="isNewCleanTransport && customerId == 45"
              >汽运统计</a
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="record_msg" v-if="tableData && tableData.length">
      <div class="record_msg_img">
        <img :src="inoutImage" alt />
      </div>
      <ul class="record_msg_txt">
        <li>
          <span class="li_label">车牌号：</span>
          <span class="li_value">
            {{ tableDataFirst.numberPlate ? tableDataFirst.numberPlate : "" }}
          </span>
        </li>
        <li>
          <span class="li_label">排放标准：</span>
          <span
            class="li_value blueFont"
            v-html="veFun(tableDataFirst.vehicleEmissions)"
          ></span>
        </li>
        <li>
          <span class="li_label">车辆识别代号：</span>
          <span class="li_value">{{
            tableDataFirst.vin ? tableDataFirst.vin : ""
          }}</span>
        </li>
        <li>
          <span class="li_label">注册日期：</span>
          <span class="li_value">
            {{
              tableDataFirst.registrationDate
                ? tableDataFirst.registrationDate
                : ""
            }}
          </span>
        </li>
      </ul>
    </div>
    <div class="table_box" style="margin-top: 20px">
      <el-table
        :data="tableData"
        style="width: 100%"
        height="100%"
        @row-click="rowClick"
      >
        <el-table-column
          prop="inOutTime"
          label="时间"
          align="center"
          width="170"
          v-if="customerId == 138"
        >
          <template #default="scope">
            <span
              :title="
                scope.row.InorOut == 1
                  ? scope.row.inTime
                  : scope.row.outTime
              "
            >
              {{
                scope.row.InorOut == 1
                  ? scope.row.inTime.slice(5, 19)
                  : scope.row.outTime.slice(5, 19)
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="inOutTime"
          label="时间"
          align="center"
          width="170"
          v-else-if="!commNew && customerId != 63"
        >
          <template #default="scope">
            <span :title="scope.row.inOutTime">
              {{ scope?.row?.inOutTime && scope?.row?.inOutTime.slice(5, 19) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="inOutTime"
          label="时间"
          align="center"
          width="170"
          v-else-if="customerId == 63"
        >
          <template #default="scope">
            <span :title="scope.row.inOutTime">
              {{ scope?.row?.inOutTime && scope?.row?.inOutTime.slice(5, 19) }}
            </span>
          </template>
        </el-table-column>
        <!--        <el-table-column-->
        <!--          prop="inTime"-->
        <!--          label="进厂时间"-->
        <!--          align="center"-->
        <!--          width="170"-->
        <!--          v-if="customerId == 63"-->
        <!--        >-->
        <!--          <template #default="scope">-->
        <!--            <span :title="scope.row.inTime">-->
        <!--              {{-->
        <!--                scope?.row?.inTime &&-->
        <!--                (scope.row.inTime == "&#45;&#45;"-->
        <!--                  ? scope.row.inTime-->
        <!--                  : scope.row.inTime.slice(5, 19))-->
        <!--              }}-->
        <!--            </span>-->
        <!--          </template>-->
        <!--        </el-table-column>-->
        <el-table-column
          prop="inTime"
          label="进厂时间"
          align="center"
          width="170"
          v-if="commNew"
        >
          <template #default="scope">
            <span :title="scope.row.inTime">
              {{
                scope?.row?.inTime &&
                (scope.row.inTime == "--"
                  ? scope.row.inTime
                  : scope.row.inTime.slice(5, 19))
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="outTime"
          label="出厂时间"
          align="center"
          width="170"
          v-if="commNew"
        >
          <template #default="scope">
            <span :title="scope.row.outTime">
              {{
                scope?.row?.outTime &&
                (scope.row.outTime == "--"
                  ? scope.row.outTime
                  : scope.row.outTime.slice(5, 19))
              }}
            </span>
          </template>
        </el-table-column>
        <!--        <el-table-column-->
        <!--          prop="outTime"-->
        <!--          label="出厂时间"-->
        <!--          align="center"-->
        <!--          width="170"-->
        <!--          v-if="customerId == 63"-->
        <!--        >-->
        <!--          <template #default="scope">-->
        <!--            <span :title="scope.row.outTime">-->
        <!--              {{-->
        <!--                scope?.row?.outTime &&-->
        <!--                (scope.row.outTime == "&#45;&#45;"-->
        <!--                  ? scope.row.outTime-->
        <!--                  : scope.row.outTime.slice(5, 19))-->
        <!--              }}-->
        <!--            </span>-->
        <!--          </template>-->
        <!--        </el-table-column>-->
        <el-table-column
          prop="numberPlate"
          label="车牌号"
          width="130"
          align="center"
        >
          <template #default="scope">
            <span :title="scope.row.numberPlate">{{
              scope.row.numberPlate
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="customerId == 60"
          prop="transportType"
          label="车辆类型"
          width="130"
          align="center"
        >
          <template #default="scope">
            <span>
              {{
                scope.row["transportType"] === 1
                  ? "大宗运输车辆"
                  : "非大宗运输车辆"
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="status"
          label="状态"
          width="80"
          align="center"
          v-if="!isNewCleanTransport"
        >
          <template #default="scope">
            <span v-if="scope.row.InorOut == 1" style="color: #47ffdd"
              >进厂</span
            >
            <span v-else style="color: #f5a623">出厂</span>
          </template> </el-table-column
        >inGatePostName
        <el-table-column
          v-if="customerId == 19"
          prop="inGatePostName"
          label="门岗SN"
          align="center"
          :filters="snFilterArr"
          :filter-method="filterHandler"
        ></el-table-column>
        <el-table-column
          v-else-if="customerId == 138"
          prop="inGatePostName"
          label="门岗SN"
          align="center"
          :filters="snFilterArr"
          :filter-method="filterHandler"
        ></el-table-column>
        <el-table-column
          v-else-if="commNew"
          prop="inGatePostCode"
          label="门岗SN"
          align="center"
          :filters="snFilterArr"
          :filter-method="filterHandler"
        ></el-table-column>
        <el-table-column
          v-else-if="!commNew"
          prop="gatePostCode"
          label="门岗SN"
          align="center"
          :filters="snFilterArr"
          :filter-method="filterHandler"
        ></el-table-column>
        <el-table-column
          prop="vehicleEmissions"
          label="排放阶段"
          align="center"
          :filters="veFilterArr"
          :filter-method="filterHandler"
        >
          <template #default="scope">
            <span v-html="veFun(scope.row.vehicleEmissions)"></span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="!commNew"
          :prop="customerId != 63 ? 'transportName' : 'materialName'"
          label="货物名称"
          align="center"
        ></el-table-column>
        <el-table-column
          v-if="commNew"
          :prop="customerId != 63 ? 'transportName' : 'inTransportName'"
          label="货物名称"
          align="center"
        >
          <template #default="scope">
            <span>
              {{
                scope.row.inTransportName
                  ? scope.row.inTransportName
                  : scope.row.outTransportName
              }}
            </span>
            <!--            <span v-if="scope.row.InorOut == 2">{{ scope.row.outTransportName ? scope.row.outTransportName : '&#45;&#45;' }}</span>-->
          </template>
        </el-table-column>
        <el-table-column
          v-if="!commNew"
          :prop="customerId != 63 ? 'transportVolume' : 'materialWeight'"
          :label="
            customerId !== 6
              ? customerId !== 41
                ? '运输量(t)'
                : '运输量(kg)'
              : '货物重量(净重t)'
          "
          align="center"
        >
          <template #default="scope">
            <span v-if="customerId != 63" :title="scope.row.transportVolume">
              {{
                customerId == 65
                  ? computedVolume(scope.row)
                  : toDecimal(scope.row.transportVolume)
              }}
            </span>
            <span v-else :title="scope.row.materialWeight">
              {{ scope.row.materialWeight }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="commNew"
          :prop="customerId != 63 ? 'transportVolumee' : 'inTransportVolum'"
          label="运输量(t)"
          align="center"
        >
          <template #default="scope">
            <span v-if="customerId != 63" :title="scope.row.transportVolume">
              {{ computedVolume(scope.row) }}
            </span>
            <span v-else>
              {{
                scope.row.inTransportName
                  ? scope.row.inTransportVolume
                  : scope.row.outTransportVolume
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="customerId == 6"
          prop="isOnSet"
          label="是否厂内倒运车辆"
          width
          align="center"
        >
          <template #default="scope">
            <span v-if="scope.row.isOnSet === 0">否</span>
            <span v-else>是</span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="customerId == 136 || customerId == 125"
          prop="model"
          label="车辆品牌"
          width
          align="center"
        >
        </el-table-column>
        <el-table-column
          v-if="customerId == 136 || customerId == 125"
          prop="onlineStatus"
          label="是否联网"
          width
          align="center"
        >
          <template #default="scope">
            <span v-if="scope.row.onlineStatus == 1">已联网</span>
            <span v-else>未联网</span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="customerId == 136 || customerId == 125"
          prop="companyNo"
          label="企业编码"
          width
          align="center"
        >
        </el-table-column>
      </el-table>
    </div>
    <div class="page_box">
      <el-pagination
        @current-change="handleCurrentChange"
        background
        :current-page="paramsList.pageNo"
        :page-size="paramsList.pageSize"
        layout="total,prev, pager, next, jumper"
        :total="page_total"
        :pager-count="4"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { dateFormat, deteleObject } from "@/utils/tools.js";
import doorTitle from "../../components/doorTitle";
import { mapState, mapGetters, mapMutations } from "vuex";
import inoutDetail from "../../components/doorDialog/inoutDetail.vue";
import listOverview from "../../components/doorDialog/listOverview.vue";
import listTransport from "../../components/doorDialog/listTransport.vue";
import inoutDetail_huale from "../../components/doorDialog/inoutDetail_huale.vue";
import { DatePicker } from "@/modules/commonDatePicker";
import carExport from "./component/carExport.vue";
import moment from "moment";
import { setPageActive } from '@/utils/platformmonitor.js'
export default {
  name: "leftRecord",
  data() {
    return {
      electricVehicle: bmeConfig.electricVehicle,
      pageInfo: "carMonitorStatistics/leftRecord.vue",
      computedName: "运输车辆电子台账组件",
      styleType: "",
      customerId: this.$store.state.customerId,
      isNewCleanTransport: bmeConfig.isNewCleanTransport,
      tableData: [],
      tableFirstData: [],
      paramsImage: {
        inOutTime: "",
        numberPlate: "",
      },
      paramsList: {
        startTime: dateFormat(
          "YYYY-mm-dd HH:MM:SS",
          new Date(new Date() - 24 * 60 * 60 * 1000)
        ),
        endTime: dateFormat("YYYY-mm-dd HH:MM:SS", new Date()),
        pageNo: 1,
        pageSize: 20,
      },
      transportType: 1,
      transportTypeList: [
        { value: 1, label: "大宗运输车辆" },
        { value: 2, label: "非大宗运输车辆" },
      ],
      page_total: 0,
      inoutImage: "",
      snFilterArr: [],
      veFilterArr: [],
      timeArr: [
        dateFormat(
          "YYYY-mm-dd HH:MM:SS",
          new Date(new Date() - 24 * 60 * 60 * 1000)
        ),
        dateFormat("YYYY-mm-dd HH:MM:SS", new Date()),
      ],
      createTime: [
        dateFormat(
          "YYYY-mm-dd HH:MM:SS",
          new Date(new Date() - 24 * 60 * 60 * 1000)
        ),
        dateFormat("YYYY-mm-dd HH:MM:SS", new Date()),
      ],
      timeArr_: [
        dateFormat(
          "YYYY-mm-dd HH:MM:SS",
          new Date(new Date() - 24 * 60 * 60 * 1000)
        ),
        "" /*dateFormat("YYYY-mm-dd HH:MM:SS", new Date()),*/,
      ],
      DOORSETINTERVAL: null,
      isThin: bmeConfig.isThin,
      isPublicCleanTransport: bmeConfig.isPublicCleanTransport,
      emissionType: "",
      emissionStandard: [
        {
          value: 3,
          label: "国Ⅲ",
        },
        {
          value: 4,
          label: "国Ⅳ",
        },
        {
          value: 5,
          label: "国Ⅴ",
        },
        {
          value: 6,
          label: "国Ⅵ",
        },
        {
          value: 99,
          label: "新能源",
        },
      ],
      bulkMaterials: "",
      bulkMaterialsArr: [
        { value: "0", label: "非大宗物料" },
        { value: "1", label: "大宗物料" },
      ],
      selectNumberPlate: "",
      materialsName: "",
      inOutFlag: "",
      timeList: [
        dateFormat(
          "YYYY-mm-dd HH:MM:SS",
          new Date(new Date() - 24 * 60 * 60 * 1000)
        ),
        dateFormat("YYYY-mm-dd HH:MM:SS", new Date()),
      ], // 天柱钢铁运输车辆电子台账起止时间
    };
  },
  computed: {
    ...mapState({ cleanTransportIp: "cleanTransportIp" }),
    ...mapGetters({
      dialogCompontent: "getDialogCompontent",
    }),
    ...mapMutations(["getPingAnPhoto"]),
    curStyleTypeVal() {
      return this.$store.state.styleType;
    },
    computedVolume() {
      return function (row) {
        if (row.InorOut == 1) {
          return row.inTransportVolume || "--";
        }
        if (row.InorOut == 2) {
          if (row.outTransportVolume && row.outTransportVolume != 0) {
            return row.outTransportVolume;
          } else {
            return row.inTransportVolume || "--";
          }
        }
      };
    },
    commNew() {
      // 通用接口，新的厂
      let flag = false;
      if (
        this.customerId == 19 ||
        this.customerId == 58 ||
        this.customerId == 59 ||
        this.customerId == 81 ||
        this.customerId == 89 ||
        this.customerId == 94 ||
        this.customerId == 54 ||
        this.customerId == 92 ||
        this.customerId == 72 ||
        this.customerId == 141 ||
        this.customerId == 142 ||
        this.customerId == 143 ||
        this.customerId == 138 ||
        this.isPublicCleanTransport
      ) {
        flag = true;
      }
      return flag;
    },
  },
  created() {
    this.styleType = this.$store.state.styleType;
    // this.rowClick({})
    // 将信息回传给父组件
    this.$emit("getLeftInfo", {
      timeInfo: this.timeList,
    });
  },
  mounted() {
    if (this.customerId == 19) {
      this.createTime = [
        dateFormat(
          "YYYY-mm-dd HH:MM:SS",
          new Date(new Date().setHours(0, 0, 0, 0))
        ),
        dateFormat("YYYY-mm-dd HH:MM:SS", new Date()),
      ];
    }

    this.msgData();
    if (this.isThin) {
      this.isThinStyle();
    }

    if (this.dateTimer) {
      clearInterval(this.dateTimer);
    }

    this.dateTimer = setInterval(() => {
      if (this.timeArr_ && !this.timeArr_[1] && !this.isFocus) {
        this.timeArr[1] = dateFormat("YYYY-mm-dd HH:MM:SS", new Date());
      }
    }, 15000);
  },
  watch: {
    curStyleTypeVal: {
      handler(newVal, oldVal) {
        this.styleType = newVal;
      },
      deep: true,
    },
  },
  methods: {
    showListOverview() {
      this.$store.commit("dialogStatus", true);
      this.$popup.open(listOverview, this.dialogCompontent, this, {});
    },
    showListTransport() {
      this.$store.commit("dialogStatus", true);
      this.$popup.open(listTransport, this.dialogCompontent, this, {});
    },
    exportExel() {
      this.$store.commit("dialogStatus", true);
      this.$popup.open(carExport, this.dialogCompontent, this, {});
    },
    isThinStyle() {
      this.$nextTick(() => {
        $(".left .door_title").css({ display: "block", "margin-top": "10px" });
        $(".left .door_title .public-form").css({
          float: "right",
          "margin-top": "10px",
          "margin-bottom": "10px",
        });
      });
    },
    pickerOptions(time) {
      if (this.customerId == 1414) {
        return (
          time.getTime() > new Date().getTime() ||
          new Date("2021-07-01 00:00:00").getTime() > time.getTime()
        );
      } else {
        return time.getTime() > new Date().getTime();
      }
    },
    async msgData() {
      if (this.DOORSETINTERVAL) {
        clearTimeout(this.DOORSETINTERVAL);
      }
      let url = this.cleanTransportIp + "/transport/inout_list";

      if (this.timeArr !== null) {
        this.paramsList.startTime = this.timeArr[0];
        this.paramsList.endTime = this.timeArr[1];
      } else {
        this.paramsList.startTime = "";
        this.paramsList.endTime = "";
      }
      if (this.customerId == 42) {
        this.paramsList.emissionType = this.emissionType;
      }
      if (this.customerId == 54) {
        this.paramsList.inOrOut = this.inOutFlag;
      }
      if (this.customerId == 60) {
        this.paramsList.transportType = this.transportType;
      } else {
        if (this.paramsList.hasOwnProperty("transportType"))
          0(this.paramsList, "transportType");
      }
      if (this.customerId == 63) {
        url = this.cleanTransportIp + "/transport/inout_list/xing_xin";
      }
      if (this.customerId == 59) {
        // url = 'http://192.168.2.31:9112/bme-access-control/' + 'ext/transport/inout_list';
        url = this.cleanTransportIp + "/ext/transport/inout_list";
      }
      if (this.isPublicCleanTransport) {
        url = this.cleanTransportIp + "/transport/inout_list";
      }
      // debugger
      let res = await this.$apiUtils.get3(url, {
        ...this.paramsList,
        customerId: this.customerId,
        // numberPlate:this.selectNumberPlate,
        // materialsName:this.materialsName,
        /*bulkMaterials:this.bulkMaterials*/
      });
      // let res = {
      //   offsetSize: 3,
      //   pageSize: 20,
      //   rowCount: 3,
      //   pageNo: 1,
      //   list: [
      //     {
      //       inGatePostCode: 'HL-N01',
      //       inTime: '2022-02-12 17:34:01.167',
      //       inTransportName: 'LNG',
      //       inTransportVolume: '6',
      //       numberPlate: '鲁FAM265',
      //       outGatePostCode: 'HL-N01',
      //       outTime: '2022-02-12 17:44:26.143',
      //       outTransportName: '--',
      //       outTransportVolume: '0',
      //       registrationDate: '20180131',
      //       vehicleEmissions: '5',
      //       vin: 'LVM4C3N93HB302880'
      //     },
      //     {
      //       vehicleEmissions: '6',
      //       gatePostCode: '杨锦公路大车门卫',
      //       transportName: '废钢',
      //       inOutTime: '2022-02-24 23:00:11.000',
      //       registrationDate: '20211121',
      //       vin: 'LFWSRXSJOK1E40611',
      //       InorOut: 1,
      //       numberPlate: '苏CJN983',
      //       transportVolume: 30.0
      //     },
      //     {
      //       vehicleEmissions: '5',
      //       gatePostCode: '杨锦公路大车门卫',
      //       transportName: '优废',
      //       inOutTime: '2022-02-24 22:59:09.000',
      //       registrationDate: '20170713',
      //       vin: 'LFWSRXRJXH1F36261',
      //       InorOut: 1,
      //       numberPlate: '苏NFT025',
      //       transportVolume: 30.0
      //     }
      //   ],
      //   firstResult: 0,
      //   pageCount: 1
      // }
      if (this.customerId === 59) {
        res &&
          res.list.forEach((r) => {
            // r.inGatePostCode = `${r.inGatePostCode},${r.outGatePostCode}`;
            if (r.inGatePostCode == r.outGatePostCode || !r.outGatePostCode) {
              r.inGatePostCode = `${r.inGatePostCode}`;
            } else {
              r.inGatePostCode = `${r.inGatePostCode},${r.outGatePostCode}`;
            }
            // r.inTransportName = `${r.inTransportName},${r.outTransportName}`;
            if (r.inTransportName === null && r.outTransportName !== null) {
              r.inTransportName = `${r.outTransportName}`;
            } else if (
              r.inTransportName !== null &&
              r.outTransportName === null
            ) {
              r.inTransportName = `${r.inTransportName}`;
            } else if (
              r.inTransportName === null &&
              r.outTransportName === null
            ) {
              r.inTransportName = `--`;
            } else if (
              r.inTransportName !== null &&
              r.outTransportName !== null
            ) {
              r.inTransportName = `${r.inTransportName},${r.outTransportName}`;
            }
            if (r.inTransportVolume == null && r.outTransportVolume == null) {
              r.inTransportVolume = "--";
            } else if (
              r.inTransportVolume == !null ||
              r.outTransportVolume !== null
            ) {
              r.inTransportVolume = `${
                parseInt(r.inTransportVolume) + parseInt(r.outTransportVolume)
              }`;
            } else if (
              r.inTransportVolume == null ||
              r.outTransportVolume != null
            ) {
              r.inTransportVolume = parseInt(r.outTransportVolume);
            } else {
              r.inTransportVolume = parseInt(r.inTransportVolume);
            }
          });
      }
      this.tableData = res && res.list;

      if (this.paramsList.pageNo === 1) {
        let idx = 0;
        if (
          this.customerId == 42 &&
          this.tableData &&
          this.tableData.length > 0
        ) {
          idx = this.tableData.length - 1;
        }
        this.tableDataFirst = this.tableData && this.tableData[idx];
        // 门禁lyy
        if (this.isPublicCleanTransport) {
          this.paramsImage.createTime = this.tableDataFirst?.createTime || "";
        } else {
          this.paramsImage.inOutTime =
            this.customerId !== 59
              ? this.tableData[0].inOutTime
              : this.tableData[0].inTime;
          if (this.customerId == 63) {
            // this.paramsImage.inOutTime =
            //   this.tableData[0].outTime != "--"
            //     ? this.tableData[0].outTime
            //     : this.tableData[0].inTime;
            this.paramsImage.outTime =
              this.tableData[0].outTime != "--"
                ? this.tableData[0].outTime
                : "";
            this.paramsImage.inTime =
              this.tableData[0].inTime != "--" ? this.tableData[0].inTime : "";
          } else if (this.customerId == 90) {
            this.paramsImage.createTime = this.tableDataFirst?.createTime || "";
          } else if (this.customerId == 92) {
            this.paramsImage.createTime =
              this.tableDataFirst?.createTime || this.createTime[0];
          } else if (this.customerId == 42) {
            this.paramsImage.inOutTime =
              this.customerId !== 59
                ? this.tableData[idx].inOutTime
                : this.tableData[idx].inTime;
          } else if (
            this.customerId == 89 ||
            this.customerId == 94 ||
            this.customerId == 54 ||
            this.customerId == 72
          ) {
            this.paramsImage.createTime = this.tableDataFirst?.createTime || "";
          }
        }
        this.paramsImage.numberPlate = this.tableData[idx]?.numberPlate;

        if (this.customerId == 19 || bmeConfig.isnewVesionTansDetail) {
          this.inoutImage = this.tableDataFirst.inImage
            ? this.tableDataFirst.inImage
            : this.tableDataFirst.outImage;
        } else {
          this.imageFun().then((res) => {
            this.inoutImage = res;
          });
        }
        // this.paramsImage.inOutTime = this.customerId !== 59 ? this.tableData[0].inOutTime : this.tableData[0].inTime
      }
      this.page_total = res.rowCount;
      this.snFilterArr = [];
      this.veFilterArr = [];
      this.tableData.forEach((x) => {
        if (
          this.customerId == 59 ||
          this.customerId == 81 ||
          this.customerId == 89 ||
          this.isPublicCleanTransport
        ) {
          this.snFilterArr.push({
            text: x.inGatePostCode,
            value: x.inGatePostCode,
          });
        } else {
          this.snFilterArr.push({
            text: x.gatePostCode,
            value: x.gatePostCode,
          });
        }

        this.veFilterArr.push({
          text: this.veFun(x.vehicleEmissions),
          value: x.vehicleEmissions,
        });
      });
      this.snFilterArr = deteleObject(this.snFilterArr);
      this.veFilterArr = deteleObject(this.veFilterArr);
      let that = this;
      that.DOORSETINTERVAL = setTimeout(() => {
        that.msgData();
      }, 30000);
    },
    async imageFun() {
      let url = this.cleanTransportIp + "/transport/inout_image";
      this.paramsImage.customerId = this.customerId;
      let res = await this.$apiUtils.get3(url, this.paramsImage);
      this.$store.commit("getPingAnPhoto", res?.inOutImage);
      return res && res?.inOutImage[0]?.inoutImage;
    },
    closeInOutDetail() {
      //debugger;
      if (this.$popup.vm) {
        if (this.$popup.vm._instance) {
          this.$popup?.vm?._instance?.ctx?.close();
        } else {
          this.$popup?.vm?.unmount();
          this.$popup?.vm?._container &&
            $(this.$popup?.vm?._container).remove();
        }
      }
      //this.$popup.close();
    },
    openInOutDetail(row) {
      let that = this;
      if (this.inOutTimer) {
        setTimeout(this.inOutTimer);
      }

      this.inOutTimer = setTimeout(() => {
        that.closeInOutDetail();
        that.$store.commit("dialogStatus", true);
        if (that.customerId == 63) {
          that.$popup.open(inoutDetail, that.dialogCompontent, that, {
            outTime: row.outTime !== "--" ? row.outTime : "",
            inTime: row.inTime !== "--" ? row.inTime : "",
            // inOutTime: (row?.inTime?.length > 6 ? row.inTime : row.outTime) ?? row.inOutTime,
            numberPlate: row.numberPlate,
          });
        } else if (that.customerId == 59 || that.isPublicCleanTransport) {
          that.$popup.open(inoutDetail_huale, that.dialogCompontent, that, {
            id: row.id,
            createTime: row.createTime,
          });
        } else if (that.customerId == 60) {
          that.$store.commit("setCloseTransportVideo", new Date().getTime());
          that.$popup.open(inoutDetail, that.dialogCompontent, that, {
            inOutTime:
              (row?.inTime?.length > 6 ? row.inTime : row.outTime) ??
              row.inOutTime,
            numberPlate: row.numberPlate,
          });
        } else if (
          that.customerId == 89 ||
          that.customerId == 92 ||
          that.customerId == 72
        ) {
          that.$popup.open(inoutDetail, that.dialogCompontent, that, {
            createTime: row.createTime,
            numberPlate: row.numberPlate,
          });
        } else if (that.customerId == 90 || that.customerId == 54) {
          that.$popup.open(inoutDetail, that.dialogCompontent, that, {
            createTime: row.createTime,
            numberPlate: row.numberPlate,
          });
        } else if (bmeConfig.isnewVesionTansDetail) {
          that.$popup.open(inoutDetail, that.dialogCompontent, that, {
            createTime: row.createTime,
            numberPlate: row.numberPlate,
          });
        } else {
          that.$popup.open(inoutDetail, that.dialogCompontent, that, {
            inOutTime:
              (row?.inTime?.length > 6 ? row.inTime : row.outTime) ??
              row.inOutTime,
            numberPlate: row.numberPlate,
          });
        }
      }, 1000);
    },
    rowClick(row) {
      this.openInOutDetail(row);
    },
    record_check_click() {
      setPageActive("清洁运输电子台账展示功能","open",true)
      this.paramsList.pageNo = 1;
      this.msgData();
      this.$emit("recordecheckclick");
    },
    record_reset_click() {
      this.timeArr_ = [
        dateFormat(
          "YYYY-mm-dd HH:MM:SS",
          new Date(new Date() - 24 * 60 * 60 * 1000)
        ),
        "" /*dateFormat("YYYY-mm-dd HH:MM:SS", new Date())*/,
      ];
      this.timeArr = [
        dateFormat(
          "YYYY-mm-dd HH:MM:SS",
          new Date(new Date() - 24 * 60 * 60 * 1000)
        ),
        dateFormat("YYYY-mm-dd HH:MM:SS", new Date()),
      ];
      this.createTime = [
        dateFormat(
          "YYYY-mm-dd HH:MM:SS",
          new Date(new Date() - 24 * 60 * 60 * 1000)
        ),
        dateFormat("YYYY-mm-dd HH:MM:SS", new Date()),
      ];
      this.paramsList.pageNo = 1;
      this.emissionType = "";
      this.selectNumberPlate = "";
      this.materialsName = "";
      this.inOutFlag = "";
      if (this.paramsList.hasOwnProperty("transportType"))
        this.transportType = 1;
      this.msgData();
      this.$emit("recordecheckclick");
      this.$emit("getLeftInfo", {
        timeInfo: [
          dateFormat(
            "YYYY-mm-dd HH:MM:SS",
            new Date(new Date() - 24 * 60 * 60 * 1000)
          ),
          dateFormat("YYYY-mm-dd HH:MM:SS", new Date()),
        ],
      });
    },
    handleCurrentChange(val) {
      this.paramsList.pageNo = val;
      this.msgData();
    },
    date_change(e) {
      console.log("myTime ---", e);
      // this.timeArr = e;
      if (this.customerId == 58 || this.customerId == 95) {
        e[0] = this.getThreeMonthDay(e[0]);
      }
      this.timeArr = [
        dateFormat("YYYY-mm-dd HH:MM:SS", new Date(e[0])),
        dateFormat("YYYY-mm-dd HH:MM:SS", new Date(e[1])),
      ];
      this.createTime = [
        dateFormat("YYYY-mm-dd HH:MM:SS", new Date(e[0])),
        dateFormat("YYYY-mm-dd HH:MM:SS", new Date(e[1])),
      ];
      this.timeList = e;
      this.$emit("getLeftInfo", {
        timeInfo: this.timeList,
      });
      this.timeArr_ = this.timeArr;
    },
    /**
     * @Description: 获取前三个月日期
     * @param {String} time 时间
     * @return element
     * @author liqiuyu
     * @date 2024/1/5
     */
    getThreeMonthDay(time) {
      let currentTime = Date.parse(time.replace(/-/g, "/"));
      let monthMap = {
        1: 31,
        2: 28,
        3: 31,
        4: 30,
        5: 31,
        6: 30,
        7: 31,
        8: 31,
        9: 30,
        10: 31,
        11: 30,
        12: 31,
      };
      let oneDay = 1000 * 60 * 60 * 24;
      let currentMonth = new Date().getMonth() + 1;
      let currentYear = new Date().getFullYear();
      let lastmonthDay = 0;
      let preMonthDay = 0;
      let preSecDay = 0;
      if (currentMonth == 1) {
        preMonthDay = monthMap[12];
        preSecDay = monthMap[11];
      } else {
        preMonthDay = monthMap[currentMonth - 1];
        if (currentMonth - 2 == 0) {
          preSecDay = monthMap[12];
        } else {
          preSecDay = monthMap[currentMonth - 2];
        }
      }
      let lastBigTime =
        new Date().getTime() -
        oneDay * (monthMap[currentMonth] + preSecDay + preMonthDay);
      if (lastBigTime > currentTime) {
        return moment(lastBigTime).format("YYYY-MM-DD HH:mm:ss");
      } else {
        return time;
      }
    },
    timeFocus() {
      this.isFocus = true;
    },
    timeBlur() {
      this.isFocus = false;
    },
    veFun(count) {
      let num = count;
      if (this.customerId == 11) {
        switch (num) {
          case "1":
            return "国三";
          case "2":
            return "国四";
          case "3":
            return "国五";
          case "4":
            return "国六";
          case "6":
            return "国零";
          case "7":
            return "国一";
          case "8":
            return "国二";
          case "9":
            return "国七";
          case "10":
            return "电动";
          case "11":
            return "无排放阶段";
          default:
            return "--";
        }
      } else if (this.electricVehicle) {
        switch (num) {
          case "1":
            return "国Ⅰ";
          case "2":
            return "国Ⅱ";
          case "3":
            return "国Ⅲ";
          case "4":
            return "国Ⅳ";
          case "5":
            return "国Ⅴ";
          case "6":
            return "国Ⅵ";
          case "D":
            return "电动";
          case "99":
            return "新能源";
          case "101":
            return "铁路运输";
          case "102":
            return "水路运输";
          case "103":
            return "管道或管状带式输送机";
          case "199":
            return "纯电";
          default:
            return "--";
        }
      } else {
        switch (num) {
          case "1":
            return "国Ⅰ";
          case "2":
            return "国Ⅱ";
          case "3":
            return "国Ⅲ";
          case "4":
            return "国Ⅳ";
          case "5":
            return "国Ⅴ";
          case "6":
            return "国Ⅵ";
          case "D":
            return "电动";
          case "99":
            return "新能源";
          case "101":
            return "铁路运输";
          case "102":
            return "水路运输";
          case "103":
            return "管道或管状带式输送机";
          default:
            return "--";
        }
      }
    },
    filterHandler(value, row, column) {
      const property = column["property"];
      return row[property] === value;
    },
    toDecimal(x) {
      var f = parseFloat(x);
      if (isNaN(f)) {
        return;
      }
      f = Math.round(x * 1000) / 1000;
      return f;
    },
  },
  unmounted() {
    clearTimeout(this.DOORSETINTERVAL);
    clearInterval(this.dateTimer);
    this.DOORSETINTERVAL = null;
  },
  components: { doorTitle, DatePicker },
};
</script>

<style lang="scss" scoped="scoped">
.left_record {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .door_title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    // white-space: nowrap;
    // height: 45px;
    padding-top: 10px;
    .form_box {
      flex: 1;
      padding-left: 50px;
      .el-form {
        flex-wrap: wrap;
        justify-content: flex-start;
      }
    }
  }
  .record_msg {
    margin-top: 30px;
    padding: 10px;
    display: flex;
    height: 220px;
    background: rgba(0, 0, 0, 0.7);
    border: 1px solid;
    border-image: linear-gradient(
        90deg,
        rgba(28, 247, 255, 1),
        rgba(28, 158, 255, 1)
      )
      1 1;
    box-sizing: border-box;
    .record_msg_img {
      width: 28%;
      height: 100%;
      margin-right: 1%;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .record_msg_txt {
      width: 71%;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      padding: 15px;
      li {
        width: 49%;
        height: 75px;
        display: flex;
        .li_label {
          color: #c8d8ff;
          display: flex;
          font-size: 16px;
          justify-content: center;
          align-items: center;
          width: 40%;
          background: linear-gradient(
            225deg,
            rgba(108, 151, 255, 0.2) 0%,
            rgba(58, 116, 255, 0.1) 100%,
            #0049fa 100%
          );
          box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.5);
          border: 1px solid;
          border-image: linear-gradient(
              90deg,
              rgba(169, 200, 251, 1),
              rgba(113, 152, 246, 0)
            )
            1 1;
        }
        .li_value {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 60%;
          background: linear-gradient(
            225deg,
            rgba(108, 151, 255, 0.2) 0%,
            rgba(58, 116, 255, 0.1) 100%,
            #0049fa 100%
          );
          box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.5);
          font-size: 20px;
          color: #47ffdd;
        }
        &:nth-of-type(odd) {
          width: 49%;
          margin-right: 2%;
        }
      }
    }
  }
  .table_box {
    background: transparent;
    overflow-x: auto;
  }
}
.left_record_green {
  padding-top: 10px;
  padding-left: 20px;
}

.left_record_blue {
  .self_btn {
    width: 120px;
    height: 40px;
    background: url("/static/img/popupImg/but_default.png") no-repeat center
      center;
    background-size: 100% 100%;
    border-radius: 4px;
    font-size: 18px;
    color: #fff;
    margin-left: 20px;
    line-height: 40px;
    &:hover {
      background: url("/static/img/popupImg/but.png") no-repeat center center;
      background-size: 100% 100%;
    }
  }
}
</style>
<style lang="scss" type="text/css">
.left_record {
  .el-pagination button {
    height: 28px !important;
    line-height: 28px !important;
  }
  .el-pagination li {
    height: 28px !important;
    line-height: 28px !important;
  }
}
.left_record_blue .el-select .select-trigger .el-input .el-input__inner {
  height: 38px;
}
.left_record_blue .el-input__suffix-inner {
  height: 38px;
  line-height: 38px;
}
.left_record_blue .public-form .el-input__inner {
  height: 38px !important;
  line-height: 38px !important;
}

.left_record .table_box .el-table th > .cell {
  white-space: initial;
  overflow: initial;
}
.left_record .table_box .el-table__body-wrapper {
  /*height: 436px!important;*/
  /* height: 344px!important; */
  height: 300px;
  overflow-x: hidden;
}
.left_record .page_box {
  margin-top: 20px;
  padding-right: 100px;
}
.page_box .el-pager li {
  background-color: transparent !important;
}
.cleanTransport_container .el-form-item__label {
  /* height: 20px; */
  font-size: 16px !important;
  font-weight: 500 !important;
  color: #99f5ff !important;
  /* line-height: 20px; */
}

.cleanTransport_container .el-form-item {
  margin-top: 0px;
  // margin-right: 38px;
  margin-right: 28px;
  margin-bottom: 0px;
}

.left_record .el-pagination .btn-prev {
  background: none !important ;
  color: white !important;
}
.left_record .el-pagination .btn-next {
  background: none !important;
  color: white !important;
}
.left_record .page_box .el-pagination {
  padding-right: 50px !important;
  font-size: 14px !important;
}
.left_record .el-pagination__editor.el-input .el-input__inner {
  height: 20px !important;
  font-size: 16px !important;
}
.left_record .el-pagination span:not([class*="suffix"]),
.el-pagination button {
  line-height: 20px;
}
.el-table-filter {
  background: #1a1818 !important;
}
</style>
